export const USER_ROLES = Object.freeze({
  SYSTEM: 1,
  SALES: 2,
  MSP: 3,
  CUSTOMER: 4,
});

export default {};
